import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  root: {
    objectFit: "contain",
    transition: "0.4s",
  },
});
